/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import { defineStore } from "pinia";

/**
 * A reactive state management store that facilitates pagination functionality.
 *
 * This store is often used to manage pagination data, keep track of the current page,
 * manage the number of items per page, and store metadata associated with paginated content.
 *
 * Key aspects supported by this store can include:
 * - Current page number.
 * - Number of items displayed per page.
 * - Total count of items.
 * - Calculated total pages based on the items count and page size.
 * - State management for navigation events like next, previous, and reset.
 *
 * Intended to be utilized in scenarios requiring dynamic and reactive pagination behavior.
 */
export const usePaginatorStore = defineStore("PaginatorStore", {
  state: () => ({
    first: 0,
  }),
  actions: {
    resetPagination() {
      this.first = 0;
    },
    setFirst(value) {
      this.first = value;
    },
  },
});
